var _rect, _rect2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWallet({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 35.5,
    height: 35.5,
    rx: 17.75,
    fill: "#F8F8FC"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 35.5,
    height: 35.5,
    rx: 17.75,
    stroke: "#EBEBEB",
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.9487 17.6193V15.4967C25.9487 14.4539 25.119 13.6017 24.0851 13.5645V12.2617C24.0851 11.5831 23.533 11.031 22.8543 11.031H19.4661L19.0285 9.81478C18.917 9.50464 18.6912 9.25681 18.3927 9.11696C18.0942 8.97708 17.7593 8.96217 17.4496 9.07491L11.3011 11.3127C10.9917 11.4253 10.7449 11.6517 10.6061 11.9503C10.4673 12.2488 10.4532 12.5835 10.5664 12.8926L10.8134 13.5669C9.80302 13.6294 9 14.4708 9 15.4967V25.0611C9 26.1275 9.86758 26.9951 10.934 26.9951H24.0147C25.0811 26.9951 25.9487 26.1275 25.9487 25.0611V22.8682C26.5443 22.7827 27.0036 22.2692 27.0036 21.6503V18.8372C27.0036 18.2183 26.5443 17.7049 25.9487 17.6193ZM25.9487 21.6503C25.9487 21.7472 25.8698 21.8261 25.7729 21.8261H22.9598C22.0873 21.8261 21.3775 21.1163 21.3775 20.2438C21.3775 19.3713 22.0873 18.6614 22.9598 18.6614H25.7729C25.8698 18.6614 25.9487 18.7403 25.9487 18.8372V21.6503ZM11.5569 12.5297C11.5351 12.4701 11.5511 12.4198 11.5626 12.3951C11.5741 12.3704 11.6023 12.3257 11.6619 12.304L17.8103 10.0662C17.8701 10.0445 17.9204 10.0606 17.9451 10.0722C17.9698 10.0838 18.0144 10.1121 18.0359 10.1719L18.345 11.031H18.1073C17.4287 11.031 16.8766 11.5831 16.8766 12.2617V13.5628H11.9354L11.5569 12.5297ZM23.0302 12.2617V13.5627H17.9315V12.2617C17.9315 12.1647 18.0104 12.0859 18.1073 12.0859H22.8543C22.9513 12.0859 23.0302 12.1647 23.0302 12.2617ZM24.0147 25.9402H10.934C10.4493 25.9402 10.0549 25.5459 10.0549 25.0611V15.4967C10.0549 15.012 10.4493 14.6176 10.934 14.6176H24.0147C24.4995 14.6176 24.8938 15.012 24.8938 15.4967V17.6065H22.9598C21.5057 17.6065 20.3226 18.7896 20.3226 20.2438C20.3226 21.6979 21.5057 22.881 22.9598 22.881H24.8938V25.0611C24.8938 25.5459 24.4995 25.9402 24.0147 25.9402Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9601 20.7707C23.2514 20.7707 23.4875 20.5346 23.4875 20.2433C23.4875 19.952 23.2514 19.7158 22.9601 19.7158C22.6688 19.7158 22.4326 19.952 22.4326 20.2433C22.4326 20.5346 22.6688 20.7707 22.9601 20.7707Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.a7783c06f6d6c82254a908dca8da2075.svg";
export { ForwardRef as ReactComponent };